import PageTitle from "../../components/PageTitle/PageTitle";
import { Box, Button, Dialog, IconButton, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialReactTable from "material-react-table";
import columns from "./DailyReportsColumns";
import { useGetDailyReports } from "../../components/ReportComponents";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../components/LoadingComponents";
import { Visibility as ViewIcon } from "@mui/icons-material";
import { todayDate } from "../../utils/utils";
import { useAuthUser } from "react-auth-kit";
import { DailyReportDateSelect } from "../../components/DailyReportDateSelect";
import DailyReportExport from "../../components/DailyReportExport/DailyReportExport";
import dayjs from "dayjs";
import { ViewPatient } from "../../components/PatientComponents";

function DailyReports(props) {
  // daily reports
  const [dailyReportDate, setDailyReportDate] = useState(new Date());
  const reportsQuery = useGetDailyReports(dailyReportDate);
  const [loaded, setLoaded] = useState(false);

  // === ViewPatient modal handling ===
  const [openViewPatient, setOpenViewPatient] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedPatientDoctor, setSelectedPatientDoctor] = useState(null);

  const handleopenViewPatient = (patient_id, org_id, doctor_id) => {
    setSelectedPatient(patient_id);
    setSelectedOrg(org_id);
    setSelectedPatientDoctor(doctor_id);
    setOpenViewPatient(true);
  };

  const handleCloseViewReport = () => {
    setOpenViewPatient(false);
  };

  // === Daily Report Export ===
  const [exportDialogOpen, setExportDialogOpen] = useState(false);

  const handleCloseExportDialog = () => {
    setExportDialogOpen(false);
  };
  const handleOpenExportDialog = () => {
    setExportDialogOpen(true);
  };

  const authUser = useAuthUser();
  let tableColumns = columns;

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <Dialog open={openViewPatient} fullScreen>
        <ViewPatient
          _editMode={false}
          patient_id={selectedPatient}
          org_id={selectedOrg}
          doctor_id={selectedPatientDoctor}
          closeModal={handleCloseViewReport}
        />
      </Dialog>

      <DailyReportExport
        open={exportDialogOpen}
        handleCancel={handleCloseExportDialog}
        handleConfirm={null}
      />

      <PageTitle title="Report Giornalieri" />
      <h2
        style={{
          textAlign: "center",
          padding: 5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <DailyReportDateSelect
          loaded={(_loaded) => setLoaded(_loaded)}
          setParentDate={(date) => setDailyReportDate(date)}
        />
        <Button onClick={handleOpenExportDialog}>Esporta</Button>
      </h2>

      {reportsQuery.isLoading ? (
        <LoadingPaper />
      ) : reportsQuery.isError ? (
        <LoadingError error={reportsQuery.error} />
      ) : (
        reportsQuery.isSuccess &&
        loaded && (
          <Paper
            style={{
              minHeight: "fitContent",
              maxWidth: "96%",
              margin: "3vh",
            }}
          >
            {reportsQuery.data?.length === 0 ? (
              <EmptyPaper
                message={"Nessun report effettuato nel giorno selezionato"}
              />
            ) : (
              <MaterialReactTable
                columns={tableColumns}
                data={reportsQuery.data.map((patient) => {
                  return { ...patient };
                })}
                initialState={{
                  density: "compact",
                  showColumnFilters: true,
                  columnVisibility: {
                    org_id:
                      authUser()?.role !== 3 && authUser().user.org_id === null,
                  },
                }}
                enableColumnFilters={true}
                enablePagination={true}
                enableBottomToolbar={true}
                enableTopToolbar={false}
                enableSorting={false}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                muiTableContainerProps={{
                  sx: {
                    overflowX: "hidden",
                  },
                }}
                enableColumnResizing
                enableFacetedValues
                enableColumnActions={false}
                enableRowSelection={false}
                enableRowActions={true}
                positionActionsColumn="last"
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      key="view"
                      onClick={() => {
                        handleopenViewPatient(
                          row.original.patient_id,
                          row.original.org_id,
                          row.original.doctor_id
                        );
                      }}
                      color="primary"
                    >
                      <ViewIcon />
                    </IconButton>
                  </Box>
                )}
              />
            )}
          </Paper>
        )
      )}
    </main>
  );
}

export default DailyReports;
